window.iAdvizeInterface = window.iAdvizeInterface || [];

window.iAdvizeInterface.push(function (iAdvize) {
  iAdvize.on("addToCart:clicked", async ({ productId, resolve, reject }) => {
    try {
      const cartUrl =
        (window.Shopify?.routes?.root || "/") + "cart/add.js";

      const response = await fetch(cartUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          items: [
            {
              id: productId,
              quantity: 1
            }
          ]
        })
      });

      if (!response.ok) {
        const error = await response.json().catch(() => null);
        console.error("iAdvize Add To Cart - Shopify error:", error);
        resolve(false);
        return;
      }

      const result = await response.json();

      console.log("iAdvize Add To Cart - success:", result);
      resolve(true);
    } catch (error) {
      console.error("iAdvize Add To Cart - error:", error);
      reject(error);
    }
  });
});